import type { i18n as I18nType, TFunction } from 'i18next'
import { useTranslation as useI18nTranslation } from 'react-i18next'

export interface UseTranslationReturn {
	t: TFunction
	i18n: I18nType
	ready: boolean
	changeLanguage: (lng: string) => Promise<void>
	currentLanguage: string
}

export const useTranslation = (namespace?: string): UseTranslationReturn => {
	const { t, i18n, ready } = useI18nTranslation(namespace)

	const changeLanguage = async (lng: string) => {
		await i18n.changeLanguage(lng)
		// Ensure the language is saved to localStorage
		localStorage.setItem('i18nextLng', lng)
	}

	return {
		t,
		i18n,
		ready,
		changeLanguage,
		currentLanguage: i18n.language,
	}
}

export default useTranslation
